import angular from 'angular';
import { fauxSelectComponent } from './fauxSelectComponent';
import 'components/sharpr/detectFocus/detectFocusModule';
import 'components/sharpr/html/bindHtml/bindHtmlModule';
import 'components/sharpr/zIndex/top/zIndexTopModule';

angular
	.module('sh.fauxSelect', ['sh.detectFocus', 'sh.bindHtml', 'sh.zIndexTop'])
	.component('shFauxSelect', fauxSelectComponent());
